import React, { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import { InputField } from "../../../../Components/formElements/InputField";
import TermsConditions from "./TermsConditions";
import RichTextEditor from "../../../../Components/Editor/RichTextEditor";
import DataTable from "react-data-table-component";

const EquipmentListEditModal = React.forwardRef((props, ref) => {
  const [editorContent, setEditorContent] = useState("");
  const [isCardVisible10, setCardVisible10] = useState(true);
  const toggleCardVisibility10 = () => {
    setCardVisible10(!isCardVisible10);
  };
  const [isCardVisible2, setCardVisible2] = useState(true);
  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };
  const [modalShowAddProduct, setModalShowAddProduct] = useState(false);
  const hideModal = () => {
    setModalShowAddProduct(false);
  };
  const [formInputs, setFormInputs] = useState({
  });

  useEffect(() => {
    if (props.equipmentData) {
      setFormInputs({
        ...props.equipmentData,
        ...props.equipmentData.info?.[0]
      });
    }
  }, [props.equipmentData]);

  //Validations
  const [validation, setValidation] = useState({

  });

  const handleInputChange = ({ target: { name, value } }) => {
    let error = "";
    setFormInputs((prevInputs) => {
      const updatedInputs = { ...prevInputs, [name]: value };
      return updatedInputs;
    });

    setValidation((prev) => ({
      ...prev,
      [name]: error,
    }));
  };

  const ServiceData = [
    {
      name: "Service Company",
      selector: (row) => row.serviceCompanyName || "--",
      sortable: true,
      width: "200px",
    },
    {
      name: "Service Date",
      selector: (row) => row.serviceDate || "--",
      sortable: true,
      width: "150px",
    },
    {
      name: "Engineer",
      selector: (row) => row.serviceEngineer || "--",
      sortable: true,
      width: "180px",
    },
    {
      name: "Type",
      selector: (row) => row.serviceType || "--",
      width: "180px",
    },
    {
      name: "Warranty",
      selector: (row) => row.serviceWarranty || "--",
      width: "150px",
    },
    {
      name: "Status",
      selector: (row) => row.status || "--",
      width: "120px",
    },
    {
      name: "Notes",
      selector: (row) => row.notes || "--",
      wrap: true,
      width: "250px",
    },
  ];

  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === "Escape" || event.keyCode === 27) {
        props.onHide();
      }
    };
    document.addEventListener("keydown", handleEscapeKey);
    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [props]);

  const initialState = {

  };

  //handle cancel modal
  const handleCancel = () => {
    setFormInputs((prev) => ({ ...prev, ...initialState }));

    props.onHide();
  };

  const handleSave = async () => {
    setFormInputs((prev) => ({ ...prev, ...initialState }));
    let obj = {
      data: formInputs,
    };
    console.log(obj)
    // setDisabled(true);
    // await ItemServiceV2.addLogisticsFuel(obj).then((item) => {
    //   if (item?.status === 200) {
    //     handleSearchFuncApi();
    //     toast.success(item?.message || "added successfully", {
    //       duration: 2000,
    //       position: "top-right",
    //     });

    //     props.onHide();
    //   } else {
    //     // setErrorMsg('*'+ item?.message);
    //     toast.error(item?.message || "Please try again !!", {
    //       duration: 4000,
    //       position: "top-right",
    //     });
    //   }
    //   setDisabled(false);
    // });
  };

  useEffect(() => {
    if (props.equipmentData) {
      const base = props.equipmentData;
      const infoItem = base.info?.[0] || {};

      setFormInputs({
        ...base,
        ...infoItem,
      });
      setEditorContent(infoItem.description || "");
    }
  }, [props.equipmentData]);

  return (
    // backdrop="static"
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      keyboard={false}
      size="xl"
      ref={ref}
      centered
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">Modify Equipment</Modal.Title>
      </Modal.Header>
      <Modal.Body className="">
        {/* Removed the two fields */}

        {/*03 */}
        <div className="accordion mb-4" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <Row className="accordion-button">
                <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                  <span className="iconLogo">ED</span>
                </Col>

                <Col xs={4} md={4} lg={4}>
                  <span className="headerTitle">Equipment Details</span>
                  <span className="subHeaderTitle">Equipment Information
                  </span>
                </Col>
              </Row>
            </h2>

            <div>
              <div className="accordion-body">
                <Row>
                  <Col xs={12} md={12} lg={12}>
                    <div className="accordion-body">
                      <Row className="pt-2 pb-4">
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Product Name"
                            placeholder=""
                            name="productName"
                            id="productName"
                            value={formInputs?.productName || ""}
                            error={validation.productName || ""}
                            onChange={handleInputChange}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Vendor"
                            placeholder=""
                            name="vendor"
                            id="vendor"
                            error={validation.vendor || ""}
                            value={formInputs?.vendor || ""}
                            onChange={handleInputChange}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Phone"
                            placeholder=""
                            name="vendorPhone"
                            id="vendorPhone"
                            error={validation.vendorPhone || ""}
                            value={formInputs?.vendorPhone || ""}
                            onChange={handleInputChange}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Email"
                            placeholder=""
                            name="vendorEmail"
                            id="vendorEmail"
                            error={validation.vendorEmail || ""}
                            value={formInputs?.vendorEmail || ""}
                            onChange={handleInputChange}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Category"
                            placeholder=""
                            name="category"
                            id="category"
                            error={validation.category || ""}
                            value={formInputs?.category || ""}
                            onChange={handleInputChange}
                          // disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Color"
                            placeholder=""
                            name="color"
                            id="color"
                            error={validation.color || ""}
                            value={formInputs?.color || ""}
                            onChange={handleInputChange}
                          // disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Material"
                            placeholder=""
                            name="material"
                            id="material"
                            error={validation.material || ""}
                            value={formInputs?.material || ""}
                            onChange={handleInputChange}
                          // disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Price"
                            placeholder=""
                            name="price"
                            id="price"
                            error={validation.price || ""}
                            value={formInputs?.price || ""}
                            onChange={handleInputChange}
                          // disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Warranty"
                            placeholder=""
                            name="warranty"
                            id="warranty"
                            error={validation.warranty || ""}
                            value={formInputs?.warranty || ""}
                            onChange={handleInputChange}
                          // disabled={true}
                          />
                        </Col>
                        <p className="commLeftRightPadding fw-bold">Product Image</p>
                        <Col xs={2} md={2} lg={2} className="commLeftRightPadding">
                          {formInputs?.imageUrl ? (
                            <img
                              src={formInputs.imageUrl}
                              className="img-fluid rounded"
                              alt="Preview"
                              style={{ maxHeight: "160px", cursor: "pointer" }}
                            />
                          ) : (
                            "--"
                          )}
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
        {/* Instructions 10*/}
        <div className="accordion mb-4" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <Row className="accordion-button">
                <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                  <i
                    className={`bi ${isCardVisible10
                      ? "bi-chevron-right"
                      : "bi-chevron-down"
                      }`}
                    onClick={toggleCardVisibility10}
                  ></i>
                </Col>
                <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                  <span className="iconLogo">I</span>
                </Col>
                <Col xs={8} md={9} lg={9}>
                  <span className="headerTitle">Instructions</span>
                  <span className="subHeaderTitle">
                    Terms and Conditions
                  </span>
                </Col>
              </Row>
            </h2>

            <div
              className={`accordion-collapse collapse show ${isCardVisible10 ? "visible" : ""
                }`}
            >
              <div className="accordion-body">
                <Row className="p-4">
                  <Col xs={12} md={12} lg={12}>
                    <RichTextEditor
                      value={editorContent}
                    // readOnly={true}
                    />
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
        {/* Service Details */}
        <div className="accordion mb-4" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <Row className="accordion-button">
                <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                  <i
                    className={`bi ${isCardVisible2
                      ? "bi-chevron-right"
                      : "bi-chevron-down"
                      }`}
                    onClick={toggleCardVisibility2}
                  ></i>
                </Col>
                <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                  <span className="iconLogo">SD</span>
                </Col>
                <Col xs={12} md={6} lg={7}>
                  <span className="headerTitle">Service Details</span>
                  <span className="subHeaderTitle">
                    Equipment Service Details
                  </span>
                </Col>
              </Row>
            </h2>

            <div
              // id="acc"
              className={`accordion-collapse collapse show ${isCardVisible2 ? "visible" : ""
                }`}

            >
              <div className="accordion-body">
                <Row>
                  <Col xs={12} md={12} lg={12}>
                    <DataTable
                      // title=""
                      columns={ServiceData}
                      data={formInputs?.info || []}
                      // progressPending={loading}
                      // paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                      // pagination
                      // paginationServer
                      // paginationTotalRows={totalRows}
                      // onChangeRowsPerPage={handlePerRowsChange}
                      // onChangePage={handlePageChange}
                      selectableRows
                    />
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
        {
          <Row className="my-4 ">
            <Col
              lg={{ span: 2, offset: 8 }}
              className="d-flex justify-content-end mt-2"
            >
              <button
                className="btnTable btn-danger"
                onClick={handleCancel}
              // disabled={disabled}
              >
                Cancel
              </button>
            </Col>
            <Col lg={2} className="d-flex justify-content-end mt-2">
              <button
                className="btnTable"
                // disabled={disabled}
                onClick={handleSave}
              >
                Save
              </button>
            </Col>
          </Row>
        }
        <TermsConditions
          show={modalShowAddProduct}
          onHide={hideModal}
        />
      </Modal.Body>
    </Modal>
  );
});

export default EquipmentListEditModal;
